<template>
  <modal name="fill-contract-details-modal"
         @closed="$emit('updateComparisonData')"
         @before-open="beforeOpen"
         @before-close="beforeClose"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Լրացնել պայմանագրի մանրամասներ</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('fill-contract-details-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4 pb-0" style="overflow-x: auto; height: 90%">
      <div class="row">
        <div class="col-6">
          <h5>Ուշադրություն!</h5>
          <h5>Կնքված պայմանագրի տվյալների մուտքագրում կցելով Excel ֆայլ</h5>
          <ol>
            <li class="mb-2">
              <span class="mr-2">Ներբեռնեք օրինակը</span>
              <a id="doc" href="/assets/dashboard/assets/files/Ակտեր.xlsx">
                <i class="far fa-file-excel text-success font-30"></i>
              </a>
            </li>
            <li class="mb-2">Լրացրեք բոլոր դաշտերը,</li>
            <li class="mb-2">Պատճենեք ձեր excel ֆայլից աղյուսակը և մուտքագրեք այստեղ</li>
          </ol>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="text-dark" for="other-requirements">Պատճենեք ձեր excel ֆայլից աղյուսակը և մուտքագրեք այստեղ</label>
            <textarea v-model="copiedExcelSheet"
                      rows="4"
                      id="other-requirements"
                      class="form-control"></textarea>
          </div>
          <div class="d-flex justify-content-end">
            <button @click="convertData" class="btn btn-primary">Արտածել</button>
          </div>
        </div>

        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="client_address">Պատվիրատուի հասցեն</label>
                <input v-model="$v.contract.client_address.$model" type="text" class="form-control" id="client_address">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="name">Պայմանագրի անվանումը</label>
                <input v-model="$v.contract.name.$model" type="text" class="form-control" id="name">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="sign_date">Կնքման ամսաթիվ</label>
                <input v-mask="'##.##.####'" placeholder="Օր.Ամիս.Տարի" v-model="$v.contract.sign_date.$model" type="text" class="form-control" id="sign_date">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="code">Ծածկագիր</label>
                <input v-model="$v.contract.code.$model" type="text" class="form-control" id="code">
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <table class="table mt-4">
            <thead>
              <tr>
                <th rowspan="2" style="width: 70px;">№</th>
                <th colspan="2">Գնման առարկայի</th>
                <th rowspan="2">Չափման միավորը</th>
                <th rowspan="2">Քանակը</th>
                <th rowspan="2">Միավորի գինը /ՀՀ դրամ/</th>
                <th rowspan="2">Ընդհանուր գումարը /ՀՀ դրամ/</th>
                <th rowspan="2">Մատակարարման ժամկետը ըստ գնման ժամանակացույցի</th>
                <th rowspan="2">Վճարման ժամկետը ըստ վճարման ժամանակացույցի</th>
              </tr>
              <tr>
                <th>անվանումը</th>
                <th>համառոտ բնութագիրը</th>
              </tr>
            </thead>
            <tbody v-if="tableData.length">
              <tr v-for="(row, index) in tableData" :key="index + Math.random()" :class="wrongRows.find(item=>item.cpvCode===row.cpvCode) && 'text-danger'">
                <td>
                  <template v-if="row.fromExcel">
                    {{ row.number }}
                  </template>
                  <template v-else>
                    <input
                      @change="(event) => {
                        changeInputsName(index, 'number', event.target.value)
                      }"
                      :value="row.number"
                      v-mask="'###'"
                      type="text"
                      class="form-control"
                    >
                  </template>
                </td>
                <td>
                  <template v-if="row.fromExcel">
                    {{ row.name }}
                  </template>
                  <template v-else>
                    <input
                      @change="(event) => {
                        changeInputsName(index, 'name', event.target.value)
                      }"
                      :value="row.name"
                      type="text"
                      class="form-control"
                    >
                  </template>
                </td>
                <td>
                  <template v-if="row.fromExcel">
                    {{ row.specification }}
                  </template>
                  <template v-else>
                    <input
                      @change="(event) => {
                        changeInputsName(index, 'specification', event.target.value)
                      }"
                      :value="row.specification"
                      type="text"
                      class="form-control"
                    >
                  </template>
                </td>
                <td>
                  <template v-if="row.fromExcel">
                    {{ row.unit }}
                  </template>
                  <template v-else>
                    <input
                      @change="(event) => {
                        changeInputsName(index, 'unit', event.target.value)
                      }"
                      :value="row.unit"
                      type="text"
                      class="form-control"
                    >
                  </template>
                </td>
                <td>
                  <template v-if="row.fromExcel">
                    {{ row.count }}
                  </template>
                  <template v-else>
                    <input
                      @change="(event) => {
                        changeInputsName(index, 'count', event.target.value);
                      }"
                      :value="row.count"
                      type="text"
                      class="form-control"
                    >
                  </template>
                </td>
                <td>
                  <template v-if="row.fromExcel">
                    {{ row.unit_price }}
                  </template>
                  <template v-else>
                    <input
                      @change="(event) => {
                        changeInputsName(index, 'unit_price', event.target.value);
                      }"
                      :value="row.unit_price"
                      type="text"
                      class="form-control"
                    >
                  </template>
                </td>
                <td>
                  <template>
                    {{ getTotalPrice(row) }}
                    {{ row.total_price }}
                  </template>
                </td>
                <td>
                  <template v-if="row.fromExcel">
                    {{ row.delivery_date }}
                  </template>
                  <template v-else>
                    <input
                      @change="(event) => {
                        changeInputsName(index, 'delivery_date', event.target.value)
                      }"
                      :value="row.delivery_date"
                      type="text"
                      class="form-control"
                    >
                  </template>
                </td>
                <td>
                  <template v-if="row.fromExcel">
                    {{ row.payment_date }}
                  </template>
                  <template v-else>
                    <input
                      @change="(event) => {
                        changeInputsName(index, 'payment_date', event.target.value)
                      }"
                      :value="row.payment_date"
                      type="text"
                      class="form-control"
                    >
                  </template>
                </td>
                <td>
                  <div>
                    <div class="row d-block">
                      <div class="col-6 mb-2">
                        <button v-if="tableData.length !== 1" @click="removeRow(index)" type="button" class="btn btn-danger">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </div>
                      <div v-if="index === tableData.length - 1" class="col-6">
                        <button @click="addRow(index)" type="button" class="btn btn-success">
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <div class="col-12">
          <div class="d-flex justify-content-end">
            <button @click="confirm" class="btn btn-primary">Հաստատել</button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FillContractDetailsModal',
  data () {
    return {
      copiedExcelSheet: '',
      wrongRows: [],
      contract: {
        id: null,
        client_address: '',
        name: '',
        sign_date: '',
        code: '',
      },
      tableData: [
        {
          number: '',
          name: '',
          specification: '',
          unit: '',
          count: '',
          unit_price: '',
          delivery_date: '',
          payment_date: '',
          fromExcel: false
        },
      ],
     }
  },
  validations: {
    contract: {
      id: { required },
      client_address: { required },
      name: { required },
      sign_date: { required },
      code: { required },
    },
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    consoleLog(data){
      console.log(data)
    },
    getContractSum(){
      let sum = 0;
      this.tableData.forEach((row) => {
        sum += row.total_price
      })
      return sum;
    },
    confirm(){
      console.log(this.tableData)
      if(!this.$v.contract.$invalid) {
        if(!this.tableData.find(row => row.total_price === 0)){
          const contractRequest = { ... this.contract};
          contractRequest.rows = this.tableData;
          contractRequest.price = this.getContractSum();
          this.$client.post(`contract/fromApplication/complete`, contractRequest).then((response) => {
            if(response){
              this.$modal.hide('fill-contract-details-modal')
            }
          }).catch(e => {
            console.log(e)
          })
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք գնման առարկայի տվյալների հաստատելու համար'
          })
        }
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար'
        })
      }
    },
    convertData(){
      if(this.copiedExcelSheet.length) {
        const rows = this.copiedExcelSheet.replace(/"((?:[^"]*(?:\r\n|\n\r|\n|\r))+([^"]|"")*)"/mg, function (match, p1) {
            return p1
                .replace(/""/g, '"')
                .replace(/\r\n|\n\r|\n|\r/g, ' ')
            ;
        }).split(/\r\n|\n\r|\n|\r/g);

        const rowModel = {
          number: '',
          name: '',
          specification: '',
          unit: '',
          count: '',
          unit_price: '',
          delivery_date: '',
          payment_date: ''
        }

        const data = []

        let isDataInvalid = false

        for(const rowString of rows) {
          if(!rowString.length) {
            continue
          }
          const columns = rowString.split(String.fromCharCode(9))
          const rowModelKeys = Object.keys(rowModel)
          console.log(columns)
          console.log(rowModelKeys)

          if(columns.filter((col) =>col!=="").length !== rowModelKeys.length) {
            isDataInvalid = true
            break
          }
          const row = rowModelKeys.reduce((obj, key, index) => {
            obj[key] = columns[index]
            return obj
          }, {})

          row.fromExcel = true;

          data.push(row);
        }

        console.log(data)

        if(isDataInvalid) {
          this.tableData = []
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Մուտքագրված տվյալները սխալ են'
          })
        } else {
          data.sort(function (a, b) {
            if (+a.lotNumber > +b.lotNumber) {
              return 1;
            }
            if (+a.lotNumber < +b.lotNumber) {
              return -1;
            }
            return 0;
          });
          this.tableData = data
        }
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'Դուք չեք մուտքագրել տվյալները'
        })
      }
    },
    getTotalPrice(row){
      row.total_price = row.count * row.unit_price;
    },
    changeInputsName(index, colIndex, value) {
      this.tableData[index][colIndex] = value
      this.tableData[index].total_price = this.tableData[index].count * this.tableData[index].unit_price
    },
    removeRow(index){
      this.tableData.splice(index, 1)
    },
    addRow(){
      this.tableData.push({
        number: '',
        name: '',
        specification: '',
        unit: '',
        count: '',
        unit_price: '',
        delivery_date: '',
        payment_date: '',
        fromExcel: false
      })
    },
    beforeOpen({params}) {
      this.resetComponent = params.resetComponent
      this.contract.code = params.code
      this.contract.id = params.id
    },
    beforeClose({params}) {
      this.resetComponent();
      this.copiedExcelSheet = '';
      this.wrongRows = [];
      this.contract = {
        id: null,
        client_address: '',
        name: '',
        sign_date: '',
        code: '',
      };
      this.tableData = [
        {
          number: '',
          name: '',
          specification: '',
          unit: '',
          count: '',
          unit_price: '',
          delivery_date: '',
          payment_date: '',
          fromExcel: false
        },
      ]
    },
  }
}
</script>
<style scoped>
  /deep/ .vm--modal {
    top: 3rem !important;
    left: unset !important;
    width: 80% !important;
    height: 80% !important;
    margin: auto;
    padding-bottom: 70px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>

